<template>
  <div class="container-video-mcp" :ref="`container-${videoUniqId}`">
    <section class="cover-video">
      <div class="video_jw">
        <div ref="videoPlaceholder" @click="PlayVideo()" class="placeholder">
          <img width="100%" :src="placeholder">
          <div class="play-container">
            <div class="play"><span class="btn-play"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>
            </svg></span></div>
          </div>
        </div>
        <div class="content-player">
          <div :id="videoUniqId"></div>
        </div>
      </div>
   </section>
  </div>
</template>

<style lang="scss">
  .video-full-inline {
    overflow: hidden;
    position: relative;
    left: calc(((100vw - 100%) / 2)*-1);
    width: 100vw;
    height: 100vh;
    margin: 35px 0;

    @media (max-width: 760.98px) {
      height: 60vh;
    }
  }
  .container-video-mcp {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    z-index: 1;

    .cover-video {
      video {
        object-fit: cover;
        width: 100%;
        height: 100vh;

        @media (max-width: 760.98px) {
          width: 100%;
        }
      }
    }

    .loop-video {
      pointer-events: none !important;

      video {
        pointer-events: none !important;
      }

      .jw-controls {
        overflow: hidden;
        display: none;
      }
    }

    .jw-controls {
      overflow: hidden;
    }

    .jw-display-controls {
      display: inline-block;
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .jw-display-icon-rewind {
      display: none !important;
    }

    .content-player {
      position: absolute;
      height: 100vh;
      width: 100vw;
      z-index: 1;
      background: #000;
    }

    .content-player {
      height: 100vh;

      @media (max-width: 760.98px) {
        height: 60vh;
      }
    }

    .jw-skin-webapp.jwplayer.jw-flag-aspect-mode {
      height: 100vh !important;

      @media (max-width: 760.98px) {
        height: 60vh !important;
      }
    }

    .jw-display-icon-next {
      display: none !important;
    }

    .jw-display-container {
      display: flex;
      height: 100%;
      text-align: center;
      align-items: center;
      justify-content: center;
    }

    .placeholder {
      height: 100vh;
      transition: opacity 0.5s ease-in-out;

      &.out {
        opacity: 0;
      }

      img {
        object-fit: cover;
        height: 100%;
        pointer-events: none;

        @media (max-width: 760.98px) {
          height: 60vh;
        }
      }
    }

    .play-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vw;

      @media (max-width: 760.98px) {
        height: 60vh;
      }

      .play {
        width: 100%;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (max-width: 760.98px) {
          height: 60vh;
        }
      }

      .btn-play {
        cursor: pointer;
        svg {
          fill: #f14036;
          width: 125px;
          height: 125px;
        }
      }
    }
  }

</style>

<script>

  export  default {
    name: 'VidepMcpViewer',
    props: {
      playVideo: {
        type: Boolean,
        default: false
      },
      videoUniqId: {
        type: String,
        default: ``
      },
      mcpId: {
        type: String,
        default: ``
      },
      bgLoop: {
        type: Boolean,
        default: false
      },
      regularPlayer: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        videoObject: {},
        videoId: '4446328'
      }
    },
    mounted() {
      this.showVideo()
      window.addEventListener('scroll', () => {
        this.validateOut()
      })
      
    },
    computed:{
      placeholder() {
        const id = this.mcpId.split(';')
        if(id[1])
          return id[1]
        return ``
      }
    },
    methods: {
      validateOut() {
        if(this.$refs[`container-${this.videoUniqId}`]) {
          const _wtop = document.querySelector('.container-fluid-introcollage').offsetTop
          const top = _wtop + this.$refs[`container-${this.videoUniqId}`].offsetTop
          const end = top + this.$refs[`container-${this.videoUniqId}`].offsetHeight
          console.log(_wtop, top, end)
          if(window.scrollY > top && window.scrollY < end) {
            this.showPlaceholder()
          }
        }
      },
      showPlaceholder() {
        this.videoObject =  window.FMG.getJWPlayerInstance(this.videoUniqId)
        this.videoObject.pause()
        setTimeout(() => {
          this.$refs['videoPlaceholder'].style.opacity = 1
        }, 100)
      },
      PlayVideo() {
        this.videoObject =  window.FMG.getJWPlayerInstance(this.videoUniqId)

        this.$refs['videoPlaceholder'].style.opacity = 0
        setTimeout(() => {
          this.$refs['videoPlaceholder'].style.display = 'none'
          this.videoObject.play()
        }, 510)
      },
      showLoop() {
        this.$refs['video_player_regular'].load()
      },
      showVideo() {

        window.FMG.playVOD({
          mcpId: this.videoId,
          nodeId: this.videoUniqId,
          autoplay: false, 
          muteAdsOnAutoplay: true,
          forceHLS: true,
          enableRating: true,
          isPrebidEnabled: true,
          isVmap: true,
          repeat: false,
          dfp: {
            prefix: 'rd.',
            advalue: 'univision_section_noticias/inicio',
            sz: '640x480'
          }
        })
      }
    }
  }

</script>
